export default {
  mounted() {
    this.el.addEventListener("paste", (e) => {
      const items = Array.from(e.clipboardData?.items || [])
      const imageItems = items.filter(item => item.type.startsWith("image/"))
      if (imageItems.length === 0) return

      e.preventDefault()

      const fileInput = this.el.querySelector("input[type='file'][data-phx-upload-ref]")
      if (!fileInput) return

      const dt = new DataTransfer()
      for (const item of imageItems) {
        const file = item.getAsFile()
        if (!file) continue
        const ext = file.type.split("/")[1] || "png"
        const name = `screenshot-${Date.now()}.${ext}`
        dt.items.add(new File([file], name, { type: file.type }))
      }

      if (dt.files.length > 0) {
        fileInput.files = dt.files
        fileInput.dispatchEvent(new Event("change", { bubbles: true }))
      }
    })
  }
}
